import React from 'react';
import { Navigate } from 'react-router-dom';

import ProtectedRoute from './ProtectedRoute';
import { isSuperAdmin } from '../../utils/auth/currentUser';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => (
  <ProtectedRoute>
    {isSuperAdmin() ? <>{children}</> : <Navigate to="/dashboard/store-summary" replace />}
  </ProtectedRoute>
);

export default AdminProtectedRoute;
